import React, { useRef, useEffect } from "react";

type MultiLineDataEditorProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onBlur: () => void;
};

const MultiLineDataEditor: React.FC<MultiLineDataEditorProps> = ({
  value,
  onChange,
  onKeyDown,
  onBlur,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      // Autofocus
      el.focus();

      // Move cursor to end
      el.selectionStart = el.value.length;
      el.selectionEnd = el.value.length;

      // Set initial height
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  }, []);

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      // Reset height to recalculate
      el.style.height = "auto";
      // Set to scrollHeight to fit content
      el.style.height = `${el.scrollHeight}px`;
    }
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && e.shiftKey) {
      // Let the default newline behavior happen
      return;
    }

    if (e.key === "Enter") {
      e.preventDefault(); // Prevent newline
      textareaRef.current?.blur(); // Finish editing
      return;
    }

    onKeyDown?.(e); // Call parent handler last
  };

  return (
    <textarea
      ref={textareaRef}
      className="data-editor"
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={onBlur}
      rows={1}
    />
  );
};

export default MultiLineDataEditor;
